import { CountryCode, MarketConfig } from '~/types'
import { CurrencyCode } from '../../api/functions/src/shopify.generated'

/**
 * Used to keep a sorted list of countries and names for the country selector
 */
export const countryList = [
	{ name: 'Norway', iso_code: CountryCode.NO },
	{ name: 'Sweden', iso_code: CountryCode.SE },
	{ name: 'Switzerland', iso_code: CountryCode.CH },
	{ name: 'United Kingdom', iso_code: CountryCode.GB },
	{ name: 'United States', iso_code: CountryCode.US },
	{ name: 'Austria', iso_code: CountryCode.AT },
	{ name: 'Belgium', iso_code: CountryCode.BE },
	{ name: 'Bulgaria', iso_code: CountryCode.BG },
	{ name: 'Croatia', iso_code: CountryCode.HR },
	{ name: 'Cyprus', iso_code: CountryCode.CY },
	{ name: 'Czechia', iso_code: CountryCode.CZ },
	{ name: 'Denmark', iso_code: CountryCode.DK },
	{ name: 'Estonia', iso_code: CountryCode.EE },
	{ name: 'Finland', iso_code: CountryCode.FI },
	{ name: 'France', iso_code: CountryCode.FR },
	{ name: 'Germany', iso_code: CountryCode.DE },
	{ name: 'Greece', iso_code: CountryCode.GR },
	{ name: 'Hungary', iso_code: CountryCode.HU },
	{ name: 'Ireland', iso_code: CountryCode.IE },
	{ name: 'Italy', iso_code: CountryCode.IT },
	{ name: 'Latvia', iso_code: CountryCode.LV },
	{ name: 'Lithuania', iso_code: CountryCode.LT },
	{ name: 'Luxembourg', iso_code: CountryCode.LU },
	{ name: 'Malta', iso_code: CountryCode.MT },
	{ name: 'Netherlands', iso_code: CountryCode.NL },
	{ name: 'Poland', iso_code: CountryCode.PL },
	{ name: 'Portugal', iso_code: CountryCode.PT },
	{ name: 'Romania', iso_code: CountryCode.RO },
	{ name: 'Slovakia', iso_code: CountryCode.SK },
	{ name: 'Slovenia', iso_code: CountryCode.SI },
	{ name: 'Spain', iso_code: CountryCode.ES }
]

export const defaultMarketConfig: MarketConfig[] = [
	{
		id: 'gid://shopify/Market/2589098230',
		store: 'EU',
		currency: CurrencyCode.EUR,
		webPresences: [{ defaultLocale: 'en', domain: 'www.auk.eco' }],
		countries: [
			CountryCode.AT,
			CountryCode.BE,
			CountryCode.BG,
			CountryCode.CY,
			CountryCode.CZ,
			CountryCode.DE,
			CountryCode.EE,
			CountryCode.ES,
			CountryCode.FI,
			CountryCode.GR,
			CountryCode.HR,
			CountryCode.HU,
			CountryCode.IE,
			CountryCode.IT,
			CountryCode.LT,
			CountryCode.LU,
			CountryCode.LV,
			CountryCode.MT,
			CountryCode.NL,
			CountryCode.PL,
			CountryCode.PT,
			CountryCode.RO,
			CountryCode.SI,
			CountryCode.SK
		],
		primary: true
	},
	{
		id: 'gid://shopify/Market/2619736310',
		store: 'EU',
		currency: CurrencyCode.DKK,
		webPresences: [{ defaultLocale: 'en', domain: 'www.auk.eco' }],
		countries: [CountryCode.DK],
		primary: false
	},
	{
		id: 'gid://shopify/Market/13677265142',
		store: 'EU',
		currency: CurrencyCode.EUR,
		webPresences: [{ defaultLocale: 'en', domain: 'www.auk.fr' }],
		countries: [CountryCode.FR],
		primary: false
	},
	{
		id: 'gid://shopify/Market/2619900150',
		store: 'EU',
		currency: CurrencyCode.CHF,
		webPresences: [{ defaultLocale: 'en', domain: 'www.auk.eco' }],
		countries: [CountryCode.CH],
		primary: false
	},
	{
		id: 'gid://shopify/Market/2619441398',
		store: 'EU',
		currency: CurrencyCode.GBP,
		webPresences: [{ defaultLocale: 'en', domain: 'www.auk.eco' }],
		countries: [CountryCode.GB],
		primary: false
	},
	{
		id: 'gid://shopify/Market/58458344',
		store: 'NO',
		currency: CurrencyCode.NOK,
		webPresences: [{ defaultLocale: 'nb', domain: 'no.auk.eco' }],
		countries: [CountryCode.NO, CountryCode.SJ],
		primary: true
	},
	{
		id: 'gid://shopify/Market/37164450072',
		store: 'SE',
		currency: CurrencyCode.SEK,
		webPresences: [{ defaultLocale: 'sv', domain: 'se.auk.eco' }],
		countries: [CountryCode.SE],
		primary: true
	},
	{
		id: 'gid://shopify/Market/61351395631',
		store: 'US',
		currency: CurrencyCode.USD,
		webPresences: [{ defaultLocale: 'en', domain: 'us.auk.eco' }],
		countries: [CountryCode.CA, CountryCode.US],
		primary: true
	}
]
